import RoundButton from '@deltek/specification-client/core/Buttons/RoundButton'
import RoundedSelect from '@deltek/specification-client/core/Forms/RoundedSelect'
import { PopoverProps } from '@material-ui/core/Popover'
import { makeStyles, Theme } from '@material-ui/core/styles'
import AddNewProductModal from 'bpm/pages/ProductsPage/AddProductDialog/AddNewProductModal'
import clsx from 'clsx'
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'

const useStyles = makeStyles((theme: Theme) => ({
    buttonContainers: {
        width: 'max-content',
        display: 'inline-flex',
    },
    buttonItem: {
        display: 'inline-block',
    },
    spaced: {
        marginRight: theme.spacing(1),
    },
}))
// value is also the route to the pages
const selectOptions = [
    {
        display: 'My Company Page',
        value: 'company',
    },
    {
        display: 'Product Listings',
        value: 'all',
    },
    {
        display: 'Submissions',
        value: 'submissions',
    },
]

export interface ProductHeaderProps {
    firmId: string
    showViewNav?: boolean
    showEditModeButton?: boolean
    showAddProductButton?: boolean
    showCompanyButton?: boolean
    selectValue?: any
    loading?: boolean
    roles?: {
        isDeltekUser?: boolean
        isDeltekAdmin?: boolean
        isDeltekPublishingAuthor?: boolean
        isDeltekAuthor?: boolean
        isBPMAdmin?: boolean
        isBPMAuthor?: boolean
    }
    onEditModeClick?: () => void
    onMenuChange?: (event: React.ChangeEvent<{ value: unknown }>) => void
    onCompanyButtonClick?: () => void
}

const ProductHeader: React.FC<ProductHeaderProps> = ({
    firmId,
    showEditModeButton,
    showViewNav,
    showCompanyButton,
    showAddProductButton,
    loading = true,
    selectValue = '',
    roles,
    onEditModeClick,
    onMenuChange,
    onCompanyButtonClick,
}) => {
    const classes = useStyles()
    const location = useLocation()

    const viewBtnRef = useRef<HTMLDivElement>(null)
    const [btnRef, setBtnRef] = useState<HTMLDivElement>()

    const menuProps: Partial<PopoverProps> = useMemo(() => {
        return {
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'right',
            },
            anchorEl: btnRef,
            getContentAnchorEl: null,
            transformOrigin: {
                vertical: 'top',
                horizontal: 'right',
            },
        }
    }, [btnRef])

    useEffect(() => {
        viewBtnRef && setBtnRef(viewBtnRef.current as HTMLDivElement)
    }, [viewBtnRef])

    const viewMenuOptions = useMemo(() => {
        return selectOptions.filter(
            (navItem) => !location.pathname.includes(navItem.value)
        )
    }, [location])

    return (
        <div className={classes.buttonContainers}>
            {showViewNav && (
                <div
                    className={clsx(classes.buttonItem, {
                        [classes.spaced]: showEditModeButton,
                    })}
                    ref={viewBtnRef}
                >
                    <RoundedSelect
                        value={selectValue}
                        options={viewMenuOptions}
                        handleChange={onMenuChange}
                        renderOptionValue={false}
                        renderValue="View"
                        menuProps={menuProps}
                    />
                </div>
            )}

            {showEditModeButton && (
                <div className={clsx(classes.buttonItem)}>
                    <RoundButton
                        hasShadow={false}
                        loading={loading}
                        data-testid="editModeButton"
                        backgroundColor="#0098D6"
                        onClick={onEditModeClick}
                    >
                        Edit Mode
                    </RoundButton>
                </div>
            )}
            {showCompanyButton && (
                <div
                    className={clsx(classes.buttonItem, {
                        [classes.spaced]: showEditModeButton,
                    })}
                    ref={viewBtnRef}
                >
                    <RoundButton
                        hasShadow={false}
                        loading={loading}
                        data-testid="MyCompanyPage"
                        backgroundColor="#0098D6"
                        onClick={onCompanyButtonClick}
                    >
                        My Company Page
                    </RoundButton>
                </div>
            )}
            {showAddProductButton && <AddNewProductModal firmId={firmId} />}
        </div>
    )
}

export default ProductHeader
